import header from './header';

export default (hosts) => header('Host', hosts);
